import axios from 'config/axiosConfig'
import { go, reading_assessment, assessments, report, reports, test_takers, admin_assessments, definitions, categories } from 'keys/apis';
import { isEmpty } from 'lodash';
import { statuses } from 'keys';
import { completedParams, getAssessmentFilters } from 'utils/filtering';
import { getCurrentSemesterAndYear } from 'utils/general';
import { visibilityStatuses1 } from 'keys/visibilityStatuses';
import { convertArrayToIdsString } from 'utils/formatter';
import setFilters from 'config/filters';

export const getAudioFileFetch = async ({ assessmentID, signal }, isTrainingAssessment) => {
    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/${assessmentID}/download_audio_file/`
    if (isTrainingAssessment)
        url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_assessments/${assessmentID}/download_audio_file/`

    if (assessmentID)
        return await axios.get(url, {
            signal,
            responseType: 'blob'
        })
}


export const getNetoAudioFileFetch = async (id, isTrainingAssessment) => {
    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/${id}/download_neto_audio_file/`
    if (isTrainingAssessment)
        url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_assessments/${id}/download_neto_audio_file/`

    return await axios.get(url, {
        responseType: 'blob'
    })
}

export const getAssessmentsFetch = ({ test_taker, model, page, pageSize, search, sorting, headerFilters, assessmentFilters, statusFilters, testTaker, signal }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params = {
        ...params, ...setFilters({ page, pageSize, search, sorting, model })
    }
    if (test_taker)
        params.test_taker = test_taker

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/`, {
        signal,
        params: params
    })
}

export const getAssessmentsTestTakers = ({ model, page, pageSize, search, sorting, headerFilters, assessmentFilters, statusFilters, testTaker, signal }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params = {
        ...params, ...setFilters({ page, pageSize, search, sorting, model })
    }
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_assessments_test_takers/`, {
        signal,
        params: params
    })
}

export const bulkCreateByLevelFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}bulk_create_by_level/`, {
        ...values
    })
}

//for save assessment in transcription , now not in use
export const saveAssessmentFetch1 = ({ assessmentID, assessment }) => {
    if (assessmentID)
        axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${assessmentID}/save/`, {
            ...assessment
        })
}



export const saveAssessmentFetch = (assessment) => {
    if (assessment)
        axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${assessment.id}/update_performing_assessment/`, {
            ...assessment
        })
}

export const getAdminAssessmentsFetch = ({ model, page, pageSize, sorting, search, signal, headerFilters, assessmentFilters, statusFilters, testTaker }, showTraingingAssessments) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters)
    params = {
        ...params, ...setFilters({ model, page, pageSize, search, sorting })
    }
    params.exclude_categories = "MULTIPLE_CHOICE_QUESTIONS"

    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}`
    if (showTraingingAssessments)
        url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_admin_assessments/`
    return axios.get(url, {
        signal,
        params: params
    })
}

// endpoint ייעודי לדף "עלות מבדקים" - מחזיר סיכום מחושב מה-BE (ממוצעים לפי קטגוריה),
// לא רשימת מבדקים גולמית, אז אין page/pageSize בכלל. לא נוגע ב-list הרגיל שמשמש מסכים קיימים
export const getAssessmentCostsSummaryFetch = ({ signal, headerFilters, assessmentFilters, statusFilters }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters)
    params.exclude_categories = "MULTIPLE_CHOICE_QUESTIONS"
    if (assessmentFilters?.marking_end_months?.length)
        params.marking_end_months = assessmentFilters.marking_end_months.map(month => month.id).join(',')

    const url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}assessment_costs_summary/`
    return axios.get(url, {
        signal,
        params: params
    })
}

export const getAssessmentDefsFetch = ({ model, page, pageSize, sorting, search, headerFilters, assessmentFilters, statusFilters, testTaker }, signal) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters)
    params = {
        ...params, ...setFilters({ model, page, pageSize, search, sorting })
    }

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}reading_assessment/definitions/get_library/`, {
        params: params
    })
}

export const getAdminAssessmentVersionsFetch = (id) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}reading_assessment/assessment_versions/${id}/get_assessment_versions/`)
}

export const getAssessmentDefTypesFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}reading_assessment/definition_types/`)
}

export const getPublishersFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}reading_assessment/publishers/`)
}

export const getReadabilityScoresFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}reading_assessment/readability_scores/`)
}

export const updateAssessmentStatusFetch = ({ status, sub_status, id }) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/update_status/`, {
        status: status,
        sub_status: sub_status
    })
}

export const startUploadAttemptFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${values.id}/start_upload_attempt/`, {
        metadata: values.metadata
    })
}

export const saveAnswersFetch = ({ answers, id }) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/save_answers/`, {
        answers: answers
    })
}

export const saveAssessmentDefFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}definitions/`, {
        ...values
    })
}

export const updateAssessmentDefFetch = (values) => {
    return axios.put(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}definitions/${values.id}/`, {
        ...values
    })
}


export const updateAssessmentDefStatusFetch = (values) => {
    return axios.put(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}definitions/${values.id}/update_status/`, {
        ...values
    })
}

export const createDuplicateAssessmentDefFetch = (id) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}definitions/${id}/create_duplicate/`)
}

export const createDuplicateAssessmentFetch = (id) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/create_duplicate/`)
}

export const updateAssessmentDefStatus = (values) => {
    return axios.pus(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}definitions/${values.id}/`)
}

export const createAssessmentFetch = (assessment) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}create_instance/`, {
        ...assessment
    })
}

export const updateToMissedFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/update_to_missed/`, {
        ...values
    })
}

export const getDashboardFetch = ({ signal }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/get_dashboard_data/`, {
        signal
    })
}

export const allocationBatteryFetch = (battery) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}bulk_create/`, {
        ...battery
    })
}

export const getAssessmentPendingIdsFetch = () => {
    const { school_year } = getCurrentSemesterAndYear()

    const params = {
        school_year: school_year?.id
    }

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/get_assessment_pending_ids/`, {
        params: params
    })
}

export const deleteAssessmentFetch = (id) => {
    return axios.delete(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/delete_assessment/`)
}

export const deleteAssessmentsFetch = (data) => {
    return axios.delete(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}delete_assessments/`, {
        data: data
    })
}

export const updateExecutionFetch = (data) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}update_execution/`, data)
}

export const getCategoriesFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${categories}`)
}

export const getFrequencyFetch = ({ signal, factored, testTaker, headerFilters, assessmentFilters, statusFilters }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    params.factored = factored

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_frequency/`, {
        signal,
        params: params
    })
}

export const getAbilitiesGroupFetch = ({ params }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}abilities_weight/`, {
        params: params
    })
}

export const getFrequencyByWordDefFetch = ({ signal, testTaker, headerFilters, assessmentFilters, statusFilters, word_def }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.word_def = word_def
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_frequency_by_word_def/`, {
        signal,
        params: params
    })
}

export const getPercentAccuracyDoughnutChart = ({ headerFilters, assessmentFilters, statusFilters, testTaker, signal }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_percent_accuracy_doughnut_chart/`, {
        signal,
        params: params
    })
}

export const getFactoredPercentAccuracyDoughnutChart = ({ headerFilters, assessmentFilters, statusFilters, testTaker, signal }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_factored_percent_accuracy_doughnut_chart/`, {
        signal,
        params: params
    })
}

export const getFluencyDoughnutChart = ({ headerFilters, assessmentFilters, statusFilters, testTaker, signal }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_fluency_doughnut_chart/`, {
        signal,
        params: params
    })
}

export const getDoughnutChartsFetch = ({ headerFilters, assessmentFilters, statusFilters, testTaker, signal, isSuperuser }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    if (!isSuperuser)
        params.visibility_status = visibilityStatuses1.VISIBLE
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_doughnut_charts/`, {
        signal,
        params: params
    })
}

export const getAssessmentProfilesFetch = ({ headerFilters, isSuperuser, assessmentFilters, statusFilters, testTaker, signal }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    if (!isSuperuser)
        params.visibility_status = visibilityStatuses1.VISIBLE
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_assessment_profiles/`, {
        signal,
        params: params
    })
}

export const getAssessmentAbilitiesFetch = ({ isSuperuser, headerFilters, assessmentFilters, statusFilters, testTaker, signal }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    if (!isSuperuser)
        params.visibility_status = visibilityStatuses1.VISIBLE
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_assessment_abilities/`, {
        signal,
        params: params
    })
}

export const getFluencyReadingDoughnutChart = ({ headerFilters, assessmentFilters, statusFilters, testTaker, signal }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_fluency_reading_doughnut_chart/`, {
        signal,
        params: params
    })
}

export const getCorrectWordPerMinuteDoughnutChart = ({ headerFilters, assessmentFilters, statusFilters, testTaker, signal }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)

    params = { ...params, ...completedParams }

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_correct_words_per_minute_doughnut_chart/`, {
        signal,
        params: params
    })
}


export const getBarChartData = ({ headerFilters, assessmentFilters, statusFilters, testTaker, testType, signal }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete
    params.test_type = testType

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_bar_chart_data/`, {
        signal,
        params: params
    })
}


export const getProsodyDoughnutChart = ({ headerFilters, assessmentFilters, statusFilters, testTaker, signal }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_prosody_doughnut_chart/`, {
        signal,
        params: params
    })
}

export const getWatingToMarkingCountFetch = () => {
    let params = {
        status: `${statuses.uploaded},${statuses.backToMarking}`,
    }
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_assessment_count/`, {
        params: params
    })
}

export const getAssessmentCountFetch = (params) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_assessment_count/`, {
        params: params
    })
}

export const getAssessmentSummaryByTestTakerFetch = ({ testTaker, headerFilters, assessmentFilters, statusFilters }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)

    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}get_assessment_summary_by_test_taker/`, {
        params: params
    })
}

export const getAssessmentReportFetch = ({ customModel, pageSize, page, search, sorting, signal, testTaker, headerFilters, assessmentFilters, statusFilters, showQuestions }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params = {
        ...params,
        ...setFilters({ customModel, page, pageSize, search, sorting })
    }
    if (assessmentFilters.no_student_battery) {
        if (assessmentFilters.no_student_battery.id == 'SINGLE')
            params.is_battery = false
        else params.is_battery = true
    }

    if (!showQuestions)
        params.exclude_categories = "MULTIPLE_CHOICE_QUESTIONS"

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${reports}/`, {
        signal,
        params: params
    })
}

export const getAssessmentReportsByBatteryFetch = (id) => {
    let nParams = {
        exclude_categories: "MULTIPLE_CHOICE_QUESTIONS"
    }

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/${id}/reports/`, {
        params: nParams
    })
}

export const cloneAssessmentFetch = (id) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/clone_assessment/`)
}

export const createVersionFetch = (id) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessment_versions/${id}/create_version/`)
}

export const generateVersionsFetch = () => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessment_versions/generate_versions/`)
}

export const getVersionOptionsFetch = (id) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessment_versions/${id}/options/`)
}

export const getStudentImprovementTrackingFetch = (assessmentFilters, layout, signal) => {
    let params = getAssessmentFilters(assessmentFilters, assessmentFilters)
    if (layout)
        params.layout_type = layout.id
    params.exclude_categories = "MULTIPLE_CHOICE_QUESTIONS"

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/get_student_batteries_improvement_tracking/`, {
        signal,
        params
    })
}

export const getAssessmentExecutionFetch = (assessmentFilters, signal) => {
    let params = getAssessmentFilters(assessmentFilters, assessmentFilters)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/get_student_batteries_execution/`, {
        signal,
        params
    })
}

// מצגת תמונת הקריאה — הקטגוריות שהוקצו והשכבות שנבדקות בהן (עמוד "מה נבדק")
export const getAssignedCategoriesFetch = (assessmentFilters, signal) => {
    let params = getAssessmentFilters(assessmentFilters, assessmentFilters)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/get_assigned_categories/`, {
        signal,
        params
    })
}

// מצגת תמונת הקריאה — נתוני התערבויות לפי דירוג (עמוד "צמצום פערים - מענים")
export const getInterventionProfilesFetch = (assessmentFilters, signal) => {
    let params = getAssessmentFilters(assessmentFilters, assessmentFilters)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/get_intervention_profiles/`, {
        signal,
        params
    })
}

export const getAssessmentResultsTrackingFetch = (assessmentFilters, order, selectedTab, signal) => {
    let params = getAssessmentFilters(assessmentFilters, assessmentFilters)
    if (assessmentFilters.layout)
        params.layout_type = assessmentFilters.layout.id
    params.exclude_categories = "MULTIPLE_CHOICE_QUESTIONS"
    if (order == "name")
        params.order_by = "name"

    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/get_student_batteries_results_tracking/`
    // if (selectedTab)
    // let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/get_assessment_results_tracking/`

    return axios.get(url, {
        signal,
        params: {
            ...params,
            date: assessmentFilters.date,
            all_semesters: assessmentFilters.all_semesters
        }
    })
}

// פירוט תלמידי מרכזי למידה לטולטיפ בגרפים — רץ במקביל לקריאה הראשית ואינו מאט אותה
export const getLearningCenterBreakdownFetch = (assessmentFilters, layout, trackingType, signal) => {
    let params = getAssessmentFilters(assessmentFilters, assessmentFilters)
    if (layout)
        params.layout_type = layout.id
    params.exclude_categories = "MULTIPLE_CHOICE_QUESTIONS"
    if (trackingType)
        params.tracking_type = trackingType

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/get_learning_center_breakdown/`, {
        signal,
        params: {
            ...params,
            date: assessmentFilters.date,
            all_semesters: assessmentFilters.all_semesters
        }
    })
}

export const getVersionWordsFetch = (id) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessment_versions2/${id}/get_version_words/`)
}

export const getWorngVersionWordsFetch = (id) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessment_versions2/${id}/get_wrong_version_words/`)
}

export const getAssessmentCommentsFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessment_comments/`)
}

export const getBatteryFetch = ({ model, pageSize, page, search, sorting, signal, testTaker, headerFilters, assessmentFilters, statusFilters }) => {
    const { profile, battery_status, battery_name, school_year, grade_of_execution, semester_of_execution } = assessmentFilters || {}

    let params = getAssessmentFilters(headerFilters, assessmentFilters, statusFilters, testTaker)
    params = {
        ...params,
        ...setFilters({ model, page, pageSize, search, sorting })
    }
    delete params.status
    delete params.sub_status
    if (school_year)
        params.school_year = school_year.id
    if (grade_of_execution)
        params.grade_of_execution = grade_of_execution.id
    if (semester_of_execution)
        params.semester_of_execution = semester_of_execution.id
    if (battery_name)
        params.battery = battery_name.id
    if (battery_status)
        params.status = battery_status?.id
    if (!isEmpty(profile))
        params.wcpm_fluency_avg_rating_index = convertArrayToIdsString(profile)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/`, {
        signal,
        params: params
    })
}

export const assignAssessmentsToBatteryFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/assign_student_batteries/`, {
        ...values
    })
}

export const sendToAiMarkingFetch = (values) => {
    const { model, assessment_ids } = values

    let model_port

    switch (model) {
        case 1:
            model_port = 8080
            break
        case 2:
            model_port = 8081
            break
        case 3:
            model_port = 8083
            break
    }

    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}wisper/trigger_transcription_view/`, {
        assessment_ids,
        model_port
    })
}

export const getStudentSummaryFetch = ({ headerFilters, assessmentFilters, testTaker, pageSize, page }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, null, testTaker)
    params = {
        ...params, ...setFilters({ page, pageSize })
    }
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/get_summary_table/`, {
        params: params
    })
}

export const updateTeacherRecommendationFetch = ({ id, teacher_recommendation }) => {
    return axios.put(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/${id}/update_recommendation/`, {
        teacher_recommendation
    })
}

export const updateNormalDistributionFetch = (id) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/update_normal_distribution/`)
}


export const updateMissingStatusFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/assign_student_batteries/`, {
        ...values
    })
}

export const updateVisibilityStatusFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/update_visibility_status/`, {
        ...values
    })
}

export const reportUploadFailureFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/${values.id}/report_upload_failure/`, {
        ...values.metadata
    })
}

export const assignAssessmentToLearningGroupFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/assign_to_group/`, {
        ...values
    })
}

export const duplicateForLearningGroupFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/duplicate_for_learning_group/`, {
        ...values
    })
}

export const duplicateForSchoolClassFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/duplicate_for_school_class/`, {
        ...values
    })
}

export const assignAssessmentToSchoolClassFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/assign_to_school_class/`, {
        ...values
    })
}

export const updateStatusFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/${values.id}/update_status/`, {
        ...values
    })
}

export const updateRedoStatusFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/${values.id}/update_redo_status/`, {
        ...values
    })
}

export const updateStuckStatusFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/${values.id}/update_stuck_status/`, {
        ...values
    })
}

export const releaseStuckStatusFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/${values.id}/release_stuck_status/`, {
        ...values
    })
}

export const getBatteriesFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}batteries/`)
}

export const createBatteryDefFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}batteries/`, {
        ...values
    })
}

export const getStudentBatteriesProfilesFetch = ({ headerFilters, assessmentFilters, testTaker }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, null, testTaker)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/get_profiles/`, {
        params: params
    })
}

export const getProfilesByCategoriesFetch = ({ headerFilters, assessmentFilters, testTaker }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, null, testTaker)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/get_category_profiles/`, {
        params: params
    })
}

export const getReadingGroupsFetch = ({ headerFilters, assessmentFilters, testTaker }) => {
    let params = getAssessmentFilters(headerFilters, assessmentFilters, null, testTaker)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/get_reading_groups/`, {
        params: params
    })
}



export const getStatusTypesFetch = (category) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}status_types/`, {
        params: category ? { category } : {}
    })
}

export const createStatusTypeFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}status_types/`, {
        ...values
    })
}

export const updateStatusTypeFetch = (values) => {
    return axios.patch(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}status_types/${values.id}/`, {
        ...values
    })
}

export const deleteStatusTypeFetch = ({ id }) => {
    return axios.delete(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}status_types/${id}/`)
}

export const printAssessmentFetch = ({ id, blurred }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}student_batteries/${id}/get_report/?blurred=${blurred ? true : false}`,
        { responseType: 'blob' }
    )
}

export const uploadAudioFileFetch = ({ id, file, metadata }) => {

    let formData = new FormData();
    formData.append("record_file", file);

    if (metadata) {
        if (metadata.file_size_bytes) formData.append("file_size_bytes", metadata.file_size_bytes);
        if (metadata.audio_duration_seconds) formData.append("audio_duration_seconds", metadata.audio_duration_seconds);
        if (metadata.device_type) formData.append("device_type", metadata.device_type);
        if (metadata.user_agent) formData.append("user_agent", metadata.user_agent);
        if (metadata.upload_duration_ms) formData.append("upload_duration_ms", metadata.upload_duration_ms);
        if (metadata.status) formData.append("status", metadata.status);
        if (metadata.error_message) formData.append("error_message", metadata.error_message);
        if (metadata.attempt_id) formData.append("attempt_id", metadata.attempt_id);
        if (metadata.start_time) formData.append("start_time", metadata.start_time);
    }

    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/upload_audio_file/`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

export const getAssessmentFetch = async ({ id, signal }, isTrainingAssessment) => {
    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/`
    if (isTrainingAssessment)
        url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_assessments/${id}/`
    return await axios.get(url, {
        signal
    })
}

export const getAdminAssessmentFetch = async ({ id, signal }, isTrainingAssessment) => {
    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/`
    if (isTrainingAssessment)
        url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_assessments/${id}/`
    return await axios.get(url, {
        signal
    })
}

export const getAssessmentDefFetch = async ({ id, signal }) => {
    return await axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${definitions}${id}/`, {
        signal
    })
}


export const getIndicationErrorsFetch = async () => {
    return await axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}assessments/get_indication_for_errors/`)
}

